import { render, staticRenderFns } from "./label-badge.vue?vue&type=template&id=a4edb788&scoped=true&"
import script from "./label-badge.vue?vue&type=script&lang=ts&"
export * from "./label-badge.vue?vue&type=script&lang=ts&"
import style0 from "./label-badge.vue?vue&type=style&index=0&id=a4edb788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4edb788",
  null
  
)

export default component.exports